"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGherkinDocument = void 0;
var gherkin_1 = require("@cucumber/gherkin");
var messages_1 = require("@cucumber/messages");
var uuidFn = messages_1.IdGenerator.uuid();
/**
 * Incrementally parses a Gherkin Document, allowing some syntax errors to occur.
 */
function parseGherkinDocument(gherkinSource) {
    var builder = new gherkin_1.AstBuilder(uuidFn);
    var matcher = new gherkin_1.GherkinClassicTokenMatcher();
    var parser = new gherkin_1.Parser(builder, matcher);
    try {
        return {
            gherkinDocument: parser.parse(gherkinSource),
        };
    }
    catch (error) {
        var gherkinDocument = void 0;
        for (var i = 0; i < 10; i++) {
            gherkinDocument = builder.getResult();
            if (gherkinDocument) {
                return {
                    gherkinDocument: gherkinDocument,
                    error: error,
                };
            }
            try {
                builder.endRule();
            }
            catch (ignore) {
                // no-op
            }
        }
        return {
            error: error,
        };
    }
}
exports.parseGherkinDocument = parseGherkinDocument;
//# sourceMappingURL=parseGherkinDocument.js.map